import { useContext } from 'react';
import { appContext } from '../../AppContext';
import { ReportHeading } from './ReportHeading';
import { Summary } from './Summary';
import { InfoBoxes } from './InfoBoxes';

export const ReportPage = ({ reportData, handleNotValidated, blockHistory }) => {
  const { files } = useContext(appContext);

  return (
    <section className="flex flex-col p-4 sm:p-6 md:p-[60px] gap-8 sm:gap-12 md:gap-[100px]">
      <div className="flex flex-col gap-6 sm:gap-8">
        <ReportHeading reportData={reportData} />
        <div className="flex flex-col lg:flex-wrap w-full rounded-lg gap-4 sm:gap-6">
          <Summary reportData={reportData} blockHistory={blockHistory} />
          <InfoBoxes
            reportData={reportData}
            blockHistory={blockHistory}
            files={files}
            handleNotValidated={handleNotValidated}
          />
        </div>
      </div>
      {/* {reportData.VALID === 1 && <ReportDataTables reportData={reportData} />} */}
      {/* <RightColumn reportData={reportData} /> */}
      {/* <EditBox reportData={reportData} setFiles={setFiles} /> */}
    </section>
  );
};

// OLD
// export const ReportPage = ({ reportData, blockchainHistory, handleNotValidated }) => {
//   const { files } = useContext(appContext);

//   return (
//     <section className="flex flex-col p-[60px] gap-[100px]">
//       <div className="flex flex-col gap-[40px]">
//         <ReportHeading reportData={reportData} />
//         <div className="flex flex-wrap w-full rounded-lg gap-[24px]">
//           <Summary reportData={reportData} blockchainHistory={blockchainHistory} files={files} />
//           <InfoBoxes
//             reportData={reportData}
//             blockchainHistory={blockchainHistory}
//             files={files}
//             handleNotValidated={handleNotValidated}
//           />
//         </div>
//       </div>
//       {reportData.VALID === '1' && reportData.VALIDATION_COMPLETE === 'true' && (
//         <ReportDataTables reportData={reportData} blockchainHistory={blockchainHistory} />
//       )}
//       {/* <RightColumn reportData={reportData} blockchainHistory={blockchainHistory} /> */}
//       {/* <EditBox reportData={reportData} setFiles={setFiles} /> */}
//     </section>
//   );
// };
